<template>

    <div class="ES-left">
    <XcxShow :banner="showparam.banner" :cates="showparam.catelist" :navs="showparam.navlist" />
    </div>

    <div class="ES-right">
        <div class="TTL-radio-btn">
        <div class="TTL-radio">
        <el-radio-group 
            v-model="param.radioname" 
            size="large" 
            @change="(val)=> {
                param.bannerview=false;
                param.cateview=false;
                param.navview=false;
                if(val=='广告设置') param.bannerview=true;
                if(val=='分类设置') param.cateview=true;
                if(val=='导航设置') param.navview=true;
            }"
        >
        <el-radio-button v-for="(item,index) in radiolists" :key="index" :label="item.name" :value="item.name" />
        </el-radio-group>
        </div>
        </div>

        <!-- banner设置 -->
        <Xcxbanner 
            v-if="param.bannerview" 
            :type="jumptypelist" 
            :jumpdatainfo="jumpdatainfo"
            @finish="(val)=> {
                if(val.type=='selectdata') {
                    $parent.JUMPVIEW({name:val.data.objname,param:{childtype:val.data.childtype,rollbackobjname:'EsXcxIndex'}})
                }else {
                    showparam.banner=val.data;
                }
            }" 
        />
        <!-- 分类设置 -->
        <Xcxcate v-if="param.cateview" @finish="(val)=> {showparam.catelist=val.data;}" />
        <!-- 导航设置 -->
        <Xcxnav v-if="param.navview" @finish="(val)=> {showparam.navlist=val.data;}" />

    </div>


</template>

<script>
import XcxShow from '@/views/EsXcx/Module/XcxShow'; //小程序首页显示
import Xcxbanner from '@/views/EsXcx/Module/Xcxbanner'; //广告设置
import Xcxcate from '@/views/EsXcx/Module/Xcxcate'; //分类设置
import Xcxnav from '@/views/EsXcx/Module/Xcxnav'; //导航设置
export default {

    components:{
        XcxShow,Xcxbanner,Xcxcate,Xcxnav
    },

    data() {
        return {
            objloading:'xcxindex',
            showparam: {
                banner:[],
                catelist:[],
                navlist:[]
            },
            param: {
                radioname:'广告设置',
                bannerview:true,
                cateview:false,
                navview:false,
            },
            radiolists:[
                {id:1,name:'广告设置'},
                {id:2,name:'分类设置'},
                {id:3,name:'导航设置'},
            ],
            jumptypelist:[],
            jumpdatainfo:'',
        }
    },

    mounted() {

        this.OnloadMethod(false); //页数初始化

    },

    methods: {


        /** 页数初始化 **/
        OnloadMethod(isfresh) {
            this.GetJumpTypes(isfresh);
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) { //组件已存在，同级兄弟元素调用时产生的操作
                if(data.param.type=='selectgoods') {
                    var param={id:data.param.data.id,name:data.param.data.name};
                    this.jumpdatainfo=JSON.stringify(param);
                }else if(data.param.type=='selecttutarial') {
                    var param={id:data.param.data.id,name:data.param.data.name};
                    this.jumpdatainfo=JSON.stringify(param);
                }else if(data.param.type=='selectmember') {
                    var param={id:data.param.data.id,name:data.param.data.name};
                    this.jumpdatainfo=JSON.stringify(param);
                }

            }else {
                
            }
        },

        /** 获取跳转类型 **/
        GetJumpTypes(isfresh) {
            this.$method.GET_JUMP_TYPES(isfresh).then((res) => {this.jumptypelist=res;console.log(res)});
        },


    },
}
</script>
<style scoped>
::-webkit-scrollbar {width:0;}
.ES-left {position:absolute;top:0;left:0;width:calc(400px - 40px);height: calc(100% - 40px);padding:20px;overflow-y: auto;font-size: 0;}
.ES-right {position:absolute;top:0;right:0;width:calc(100% - 400px - 40px);height: calc(100% - 40px);padding:0 20px 20px 20px;overflow-y: auto;font-size: 0;}
::v-deep(.TTL-radio .el-radio-button__inner) {font-size:12px;}
::v-deep(.TTL-radio .el-radio-button__inner:hover) {color:#47494c}
.TTL-radio-btn {position:sticky;top:0;z-index:10;padding:20px 0;background-color: #ffffff;}
</style>